<template>
	<view>
		<view class="cu-form-group margin-top">
			<view class="title">库位</view>
			<input v-model="locNo" placeholder="库位编号" name="input" ></input>
		</view>
		<view class="cu-form-group margin-top">
			<view class="title">产品</view>
			<input v-model="matNo" placeholder="产品信息" name="input"></input>
		</view>
		<view>
			<button class='cu-btn bg-yellow pda-btn'>搜索</button>
			<button class="cu-btn bg-grey pda-btn" @click="reset">重置</button>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				locNo:'',
				matNo:'',
			}
		},
		methods: {
			reset:function() {
				let that =this;
				that.locNo = '';
				that.matNo = '';
				console.log(1)
			},
		}
	}
</script>

<style>

</style>
